module.exports = __webpack_public_path__ + "assets/icons/ic_header_user_24px.svg";